module.exports = __webpack_public_path__ + "officialStatic/img/soft13.a827fc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/soft13.png
// module id = W+L6
// module chunks = 0